import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  CircularProgress,
  Alert
} from '@mui/material';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import api from '../services/api';

interface Winner {
  id: number;
  draw: {
    title: string;
    campaign: {
      title: string;
    };
  };
  coupon: {
    number: string;
    store: {
      name: string;
    };
    seller: string;
  };
  winningDate: string;
}

const Winners = () => {
  const [winners, setWinners] = useState<Winner[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchWinners = async () => {
    try {
      const response = await api.get('/winners', {
        params: {
          page: page + 1,
          limit: rowsPerPage,
        },
      });
      setWinners(response.data.items);
      setTotalCount(response.data.total);
    } catch (error) {
      console.error('Erro ao buscar ganhadores:', error);
    }
  };

  useEffect(() => {
    fetchWinners();
  }, [page, rowsPerPage]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box p={3}>
      <Typography variant="h4" component="h1" gutterBottom>
        Ganhadores
      </Typography>

      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Campanha</TableCell>
                <TableCell>Sorteio</TableCell>
                <TableCell>Número do Cupom</TableCell>
                <TableCell>Loja</TableCell>
                <TableCell>Vendedor</TableCell>
                <TableCell>Data do Prêmio</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {winners.map((winner) => (
                <TableRow key={winner.id}>
                  <TableCell>{winner.draw.campaign.title}</TableCell>
                  <TableCell>{winner.draw.title}</TableCell>
                  <TableCell>
                    <Chip
                      label={winner.coupon.number}
                      color="primary"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>{winner.coupon.store.name}</TableCell>
                  <TableCell>{winner.coupon.seller}</TableCell>
                  <TableCell>
                    {format(new Date(winner.winningDate), "dd 'de' MMMM 'de' yyyy", {
                      locale: ptBR,
                    })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Itens por página"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </Paper>
    </Box>
  );
};

export default Winners; 